module.exports = __webpack_public_path__ + "static/img/mnjy@2x.ba462a5c.png";